__turbopack_context__.v({
  "root": "FoldersTypeFilter-module___sS4Ha__root",
  "select": "FoldersTypeFilter-module___sS4Ha__select",
  "shared": "FoldersTypeFilter-module___sS4Ha__shared",
});
